import React from 'react';
import { ResidentialSolutions } from '../components/ResidentialSolutions';
export function ResidentialPage() {
  return <main data-id="element-344">
      <ResidentialSolutions data-id="element-345" />
    </main>;
}